import React from 'react'
import './Solution.css'
import gif1 from './../../Assets/video1.gif'
import gif2 from './../../Assets/video2.gif'


function Solution() {

    const observer = new IntersectionObserver((enteries) => {
        enteries.forEach((entry) => {
          console.log(entry);
          if(entry.isIntersecting){
            entry.target.classList.add('show2');
          }
        })
      })
    
      setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.hidden2');
      hiddenElements.forEach((el) => observer.observe(el));
      });


    return (
        <div id='solution_lan'>
            <div className='hidden2'>
              <img src={gif1}/>
              <img src={gif2}/>
            </div>
        </div>
    )
}

export default Solution
